import { defineStore } from 'pinia'
import { ref } from "vue";

export const useLoadingStore = defineStore('loading', () => {
  const items = ref([]);
  const progress = ref(0);
  const loading = ref(false);
  const loadedCallbacks = ref([]);

  const recalculateQueue = () => {
    if(!items.value.length) {
      return;
    }

    loading.value = true;

    if(items.value.every((item) => item.finished)) {
      return finishLoadingQueue();
    }

    const calculatedProgress = (items.value.filter((item) => item.finished).length
      / items.value.length) * 100;

    progress.value = calculatedProgress > 0 ? calculatedProgress : 1;
  };

  const finishLoadingQueue = () => {
    progress.value = 100;
    loadedCallbacks.value.forEach((callback) => callback())
    loadedCallbacks.value = [];

    setTimeout(
      () => {
        loading.value = false;
        progress.value = 0;
      },
      1000
    );
    items.value = [];
  };

  const push = (promise) => {
    const finished = ref(false);
    items.value.push(
      {
        promise: promise.finally(() => {
          finished.value = true;
          recalculateQueue();
        }),
        finished
      }
    );
    recalculateQueue();
  };

  const onLoaded = (callback) => {
    loadedCallbacks.value.push(callback);
  };

  const setLoadingProgress = (value) => {
    if(value >= 100) {
      return finishLoadingQueue();
    }

    loading.value = true;
    progress.value = value;
  }

  const addLoadingProgress = (value) => {
    setLoadingProgress(value + progress.value);
  }

  return { loading, progress, push, onLoaded, setLoadingProgress, addLoadingProgress };
});
